import requestTimeout from '../../Utils/Functions/requestTimeout';
import { useState, useContext } from 'react';
import { AccountContext } from '../../AccountContext';
import { useNavigate } from 'react-router-dom';
import { useToast } from '@chakra-ui/react';
import { api } from 'api/api';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useModelCartao = (vals) => {
  const { user, setUser } = useContext(AccountContext);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [excluido, setExcluido] = useState(false);
  const [cartaoCadastrado, setCartaoCadastrado] = useState(false);
  const [retornoCartao, setRetorno] = useState('');
  const [creditCards, setCreditCards] = useState(user?.cards);
  const [error_message, setErrorMessage] = useState(null);
  const timeOutInSeconds = process.env.REACT_APP_REQUEST_TIMEOUT_IN_SECONDS;
  const navigate = useNavigate();
  const toast = useToast();

  function callToast(title, descricao, type) {
    toast({
      title: title,
      description: descricao,
      status: type,
      duration: 4000,
      isClosable: true,
      position: 'bottom',
      colorScheme: 'red',
      containerStyle: {
        paddingTop: '50px',
      },
    });
  }

  async function cadastrarCartao() {
    setLoading(true);
    const dados = vals.dados;
    const onlyNumbers = (str) => str.replace(/[^0-9]/g, '');
    api(`${ENDPOINT}/pagamento/criar-cartao`, {
      method: 'POST',
      body: JSON.stringify({
        cpf: user?.cpf,
        number: onlyNumbers(dados.cardNumber),
        holder_name: dados.card_holder_name,
        holder_document: onlyNumbers(dados.cpf),
        exp_month: dados.expirationDate.split('/')[0],
        exp_year: dados.expirationDate.split('/')[1],
        cvv: dados.cvv,
      }),
      headers: {
        Accept: '/',
        'Content-Type': 'application/json',
      },
    })
      .then((response) => response.json())
      .then((response) => {
        setLoading(false);
        console.log(typeof response);
        console.log(response);
        console.log(JSON.stringify(response)); //{"success":true,"customer_id":3071793,"cartao_hash":1769595}

        if (response && response.cartao_hash !== undefined && response.cartao_hash !== null) {
          console.log('response ', response);
          api(`${ENDPOINT}/client/add_credit_card`, {
            signal: requestTimeout(timeOutInSeconds).signal,
            method: 'POST',
            credentials: 'include',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              paciente_id: user.id_cliente_deovita,
              first_digits: response.first_six_digits,
              last_digits: response.last_four_digits,
              brand: response.brand,
              holder_name: response.holder_name,
              holder_document: response.holder_document,
              expiration_date: `${response.exp_month.toString().padStart(2, '0')}/${(response.exp_year % 100).toString().padStart(2, '0')}`,
              card_id_pagarme: null,
              vindi_card_id: response.cartao_hash,
              fingerprint_card_pagarme: null,
              default: user.cards.length > 0 ? false : true,
              vindi_user_id: response.customer_id,
              cpf_logado: user?.cpf,
            }),
          })
            .catch((error) => {
              console.log(error);
              setCartaoCadastrado(false);
              setError(true);
              return;
            })
            .then((res) => {
              if (!res || !res.ok || res.status >= 400) {
                setCartaoCadastrado(false);
                setError(true);
                return;
              }
              return res.json();
            })
            .then(async (data) => {
              if (data?.success === 'false' || data?.success === false) {
                setRetorno(data?.msg);
                return;
              }
              setLoading(false);
              if (!data) return;
              if (data.success || data.success === 'true') {
                if (vals.editar) {
                  await editarCartao(response.cartao_hash);
                }
                setCartaoCadastrado(true);
                setError(false);
                await searchCartoesAtualizados(user?.id_cliente_deovita);
              } else {
                setRetorno(data?.msg);
                setCartaoCadastrado(false);
                setError(true);
              }
            });
        } else {
          setCartaoCadastrado(false);
          setError(true);
          setErrorMessage(response.error.message);
        }
      })
      .catch((err) => {
        setCartaoCadastrado(false);
        setError(true);
        setErrorMessage('Não foi possível concluir a solicitação. Tente novamente mais tarde.');
      });
  }
  async function editarCartao(cardId) {
    console.log({
        vindi_card_id: vals?.cartaoState?.card_id,
        paciente_id: vals?.cartaoState?.paciente_id,
        card_id_novo: cardId,
      })
    api(`${ENDPOINT}/client/desativar-cartao-anterior`, {
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify({
        vindi_card_id: vals?.cartaoState?.card_id,
        paciente_id: vals?.cartaoState?.paciente_id,
        card_id_novo: cardId,
      }),
    })
      .catch((error) => {
        setLoading(false);
        setError(true);
        return;
      })
      .then((res) => {
        if (!res || !res.ok || res.status >= 400) {
          setLoading(false);
          setError(true);
          callToast('Erro', 'Não foi possível definir o cartão como principal.', 'error');
          return;
        }
        return res.json();
      })
      .then(async (resposta) => {});
  }

  async function excluirCartao() {
    if (!vals.cardId) {
      setLoading(false);
      setError(true);
      setExcluido(false);
      return;
    }
    setLoading(true);
    api(`${ENDPOINT}/client/rm_credit_card/${vals.cardId}`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    })
      .catch((error) => {
        setLoading(false);
        setError(true);
        setExcluido(false);
        return;
      })
      .then((res) => {
        if (!res || !res.ok || res.status >= 400) {
          setLoading(false);
          //navigate('/perfil/pagamento/status-cartao', { state: { sucesso: false } });
          return;
        }
        return res.json();
      })
      .then((data) => {
        setLoading(false);
        if (!data) return;
        if (data.success) {
          let newCards = user.cards.filter((creditCard) => creditCard.card_id !== vals.cardId);
          setUser((prevState) => ({ ...prevState, cards: newCards }));
          //navigate('/perfil/pagamento/status-cartao', { state: { sucesso: true } });
          setError(false);
          setExcluido(true);
        } else {
          //navigate('/perfil/pagamento/status-cartao', { state: { sucesso: false } });
          setLoading(false);
          setError(true);
          setExcluido(false);
        }
      });
  }

  async function definirCartaoPrincipal() {
    const card_id = vals.card_id;
    api(`${ENDPOINT}/client/stamp-default-card/${card_id}`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    })
      .catch((error) => {
        setLoading(false);
        setError(true);
        return;
      })
      .then((res) => {
        if (!res || !res.ok || res.status >= 400) {
          setLoading(false);
          setError(true);
          callToast('Erro', 'Não foi possível definir o cartão como principal.', 'error');
          return;
        }
        return res.json();
      })
      .then((data) => {
        setLoading(false);
        if (!data) return;
        if (data.success) {
          setError(true);
          setCreditCards((cardsList) => {
            return cardsList.map((card) => ({
              ...card,
              default: card.card_id === card_id,
            }));
          });
          setUser((user) => {
            return {
              ...user,
              cards: creditCards,
            };
          });
          callToast('Sucesso', 'Cartão principal definido com sucesso.', 'success');
          navigate('/perfil/menu-pagamentos');
        } else {
          callToast('Erro', 'Não foi possível definir o cartão como principal.', 'error');
          setLoading(false);
        }
      });
  }

  async function searchCartoesAtualizados(paramId) {
    console.log(user.id_cliente_deovita || paramId)
    api(`${ENDPOINT}/clients/getCreditCardsByClient/${user.id_cliente_deovita || paramId}`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
    })
      .catch((error) => {
        setLoading(false);
        setError(true);
        return;
      })
      .then(async (res) => {
        if (!res || !res.ok || res.status >= 400) {
          setLoading(false);
          setError(true);
          return;
        }
        return await res.json();
      })
      .then(async (resposta) => {
        console.log("resposta ", resposta)
        setUser((prevState) => {
          return {
            ...prevState,
            cards: resposta,
          };
        });
      });
  }

  return {
    cadastrarCartao,
    editarCartao,
    excluirCartao,
    definirCartaoPrincipal,
    loading,
    error,
    excluido,
    cartaoCadastrado,
    retornoCartao,
    searchCartoesAtualizados,
    error_message,
  };
};

export default useModelCartao;
